import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const MapWrapper = styled(Box)`
  width: 100%;
  flex: 1;
  z-index: 2;
`
